module.exports = __webpack_public_path__ + "static/media/delete.5c3fbb46.svg";